import type { BrowserSession, CaptureOptions, MediaTrack, PublishOptions } from "@hololive/browser-sdk";

type LocalMediaSession = Pick<BrowserSession, "capture" | "publish" | "unpublish">;

export async function captureAndPublish(session: LocalMediaSession, options: CaptureOptions, publishOptions: (track: MediaTrack) => PublishOptions = () => ({})): Promise<MediaTrack[]> {
  const tracks = await session.capture(options);
  try {
    for (const track of tracks) await session.publish(track, publishOptions(track));
    return tracks;
  } catch (error) {
    await Promise.all(tracks.map((track) => session.unpublish(track.track_id).catch(() => undefined)));
    throw error;
  }
}

export async function releaseCapture(session: LocalMediaSession, tracks: MediaTrack[]): Promise<void> {
  await Promise.all(tracks.map((track) => session.unpublish(track.track_id)));
}
